<template>
  <div v-show="!token && yhsm == '1' && qyrz != '/qyrz'" class="block">
     <div class="add_xf" @click="xjxf()">新建信用培训</div>
		 
		 <el-dialog
		   :visible.sync="titleShow"
		   width="50%"
		   :lock-scroll='false'
		   size="tiny">
		   <div class="title">
		 	  <h2>企业材料准备指南</h2>
		 	  <div class="title1">
		 		  <p class="color_bold">请先准备好以下材料，以备上传：</p>
		 		  <p class="color_bold">一、处罚资料（一处罚一套资料）</p>
		 		  <ol>
		 			  <li>1、信用培训承诺书<i>*</i>（要求：加盖公章以及法定代表人签字，不可是法人章，不留空白）</li>
		 			  <li>2、处罚通知书</li>
		 			  <li>3、已履行处罚证明材料<i>*</i>（处罚部门出具的罚款单据并盖处罚部门/收款银行公章<strong>（原件）</strong>）</li>
		 		  </ol>
		 	  </div>
		 	  <div class="title1">
		 		  <p class="color_bold">二、企业信息</p>
		 		  <ol>
		 			  <li>4、营业执照原件或复印件<i>*</i><strong>（清淅）</strong></li>
		 			  <li>5、法定代表人身份证原件或复印件<i>*</i><strong>（清淅）</strong></li>
		 		  </ol>
		 	  </div>
		 	  <div class="title1" style="margin-bottom: 0;">
		 		  <p class="color_bold">三、公益资料</p>
		 		  <ol>
		 			  <li>6、其他：如社公公益活动资料</li>
		 		  </ol>
		 	  </div>
		   </div>
		   <span slot="footer" class="dialog-footer">
			   <a @click="updateXy" class="updexy">信用承诺书模板下载</a>
		       <el-button @click="titleShow = false">取 消</el-button>
		       <el-button type="primary" @click="showQyrz">确 定</el-button>
		   </span>
		 </el-dialog> 
  </div>
</template>
<script>
import { cookie } from "@/common/js/cookies.js";
export default {
  name: "xyxf",
  props:['yhsm'],
	data(){
		return {
			qyrz: null,
			titleShow: false	//企业材料指南
		}
	},
  computed: {
    token() {
      return cookie.get("xyxf_token_qt");
    }
  },
  created() {
    // console.log(this.$store.state.yhsm);
	this.qyrz = this.$route.path;
	// console.log(this.qyrz)
  },

  methods: {
	//点击下载信用承诺书
	updateXy(){
		let _self = this;
		let ajax = _self.$http.create();
		ajax({
		method: "post",
		url: SOWINURL + "report/cnsFj",
		headers:{
		    'token': cookie.get("xyxf_token_qt")
		}
		})
		.then(function(json) {
		  // console.log(json.data.data.fjurlmbdz)
		  window.location.href = json.data.data.fjurlmbdz
		  // window.open(json.data.data.fjurlmbdz)
		})
		.catch(function(error) {
		  console.log(error);
		})
	},
		//点击确定时才跳转页面
		showQyrz(){
			this.$router.push({path: '/qyrz'});
			this.titleShow = false;
		},
    //判断实名认证
    xjxf() {
		if (!cookie.get("xyxf_token_qt")) {
		  window.location.href = SOWINURL + "index/login";
		}else{
			this.titleShow = true;
		}
    }
  }
};
</script>
<style  scoped lang="less" type="text/less">
.updexy{
	font-size: 14px;
	color: #0076ff;
	padding-right: 30px;
	text-decoration: underline;
	cursor: pointer;
}
.title{
	padding-left: 30px;
}
.dialog-footer{
	margin-right: 30px;
}
.title h2{
	text-align: center;
	font-size: 18px;
	height: 18px;
	line-height: 18px;
	color: #333;
	margin-bottom: 40px;
}
.title1{
	line-height: 45px;
	color: #333;
	font-weight: 300;
	padding-left: 30px;
	margin-bottom: 30px;
}
.title1 i{
	color: red;
}
.color_bold{
	font-weight: 700;
}


	.block{
		display: inline-block;
		float: right;
		margin-right: 15px;
	}
.xjxf {
  background: -webkit-linear-gradient(
    left,
    #0076ff,
    #00c9ff
  ); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(
    right,
    #0076ff,
    #00c9ff
  ); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(
    right,
    #0076ff,
    #00c9ff
  ); /* Firefox 3.6 - 15 */
  background: linear-gradient(to right, #0076ff, #00c9ff); /* 标准的语法 */
  width: 210px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #fff;
  font-weight: bold;
  font-size: 22px;
  border-radius: 30px;
  cursor: pointer;
}
.add_xf {
  // float: right;
  width: 140px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  background: -webkit-linear-gradient(
    left,
    #0076ff,
    #00c9ff
  ); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(
    right,
    #0076ff,
    #00c9ff
  ); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(
    right,
    #0076ff,
    #00c9ff
  ); /* Firefox 3.6 - 15 */
  background: linear-gradient(to right, #0076ff, #00c9ff); /* 标准的语法 */
  border-radius: 15px;
  font-weight: normal;
  margin-top: 17px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/publicXyxf.vue